import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import arrowDownIcon from 'assets/images/icons/dropdown-arrow-grey.svg';
import Error from 'components/Error';
import FormButton from 'components/form-components/FormButton';
import FormLoadingButton from 'components/form-components/FormLoadingButton';
import SelectField from 'components/form-components/SelectField';
import { CallAPI } from 'actions/General';
import { useTranslation } from 'react-i18next';

const EmailSettings = ({ companyDetails, getCompanyDetail }) => {
  const { t } = useTranslation();
  const [values, setValues] = useState({ senderEmail: '' });
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  const emailsList = [
    { displayValue: 'Not Selected', value: null },
    { displayValue: 'Default: reports@ticom.group', value: 'reports@ticom.group' },
    { displayValue: 'Lawyer: reports@eye-compliance.com', value: 'reports@eye-compliance.com' },
    // { displayValue: 'Lawyer: e.lawyer@eye-compliance.com', value: 'e.lawyer@eye-compliance.com' },
    // { displayValue: 'Default: no-reply@midani.co', value: 'no-reply@midani.co' },
  ];
  const emailsListMap = Object.fromEntries(emailsList.map((v) => [v.value, v.displayValue]));

  useEffect(() => {
    // const emailAddress = 'no-reply@midani.com';
    setValues({ ...values, senderEmail: companyDetails?.senderEmail ?? null });
  }, [companyDetails]);

  const handleChange = (field, value) => {
    setValues({ ...values, [field]: value });
  };

  const submit = async () => {
    // if (!values.senderEmail) {
    //   toast.error(t('error email is a required field'));
    //   return;
    // }
    const payload = { senderEmail: values.senderEmail };
    const result = await CallAPI('UPDATE_COMPANY_DETAIL', payload, null, setLoading, setApiError);

    if (result.status) {
      toast.success(t('alert_operation_completed_successfully'));
      getCompanyDetail();
    }
  };

  return (
    <>
      <div className='px-4 py-3'>
        {apiError && (
          <div className='mb-2'>
            <Error msg={apiError} />
          </div>
        )}
        <SelectField
          placeholder='field_sender_email_address'
          label={emailsListMap[values.senderEmail] ?? 'select_select'}
          listValues={emailsList}
          icon={arrowDownIcon}
          handleChange={handleChange}
          name={'senderEmail'}
          isAutoClose={true}
          variant='white-1'
          menuClasses={'w-100'}
          isHorizontal
        />

        <div className='mt-3  w-100 d-flex justify-content-end gap-3'>
          <FormButton text='button_cancel' variant='white-1' />
          <FormLoadingButton
            onClick={submit}
            loading={loading}
            text='button_save'
            variant='green-1'
          />
        </div>
      </div>
    </>
  );
};

EmailSettings.propTypes = {
  companyDetails: PropTypes.object,
  getCompanyDetail: PropTypes.func.isRequired,
};

export default EmailSettings;
